"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareMultipleValue = void 0;
const prepareMultipleValue = (value) => {
    if (typeof value !== 'string' || value === '') {
        return '';
    }
    return value
        .replace(/(;)|(\s)/g, (match, separator) => (separator ? `${separator} ` : ''))
        .trim();
};
exports.prepareMultipleValue = prepareMultipleValue;
//# sourceMappingURL=prepareMultipleValue.js.map